import { render, staticRenderFns } from "./SubmitFormStages.vue?vue&type=template&id=535ac79e&"
import script from "./SubmitFormStages.vue?vue&type=script&lang=js&"
export * from "./SubmitFormStages.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFormStages.vue?vue&type=style&index=0&id=535ac79e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports